import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './login/login.component';
import { AdminModule } from './modules/admin/admin.module';
import { PublicComponent } from './public/public.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(ptBr);

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        PublicComponent,
        VehicleDetailsComponent,
        FooterComponent
    ],
    imports: [
        NgxMaskModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        AppRoutingModule,
        AdminModule,
        SlickCarouselModule,
        HttpClientModule
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
